<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length > 1 ? "UPDATE" : "ADD NEW" }}
        PRODUCT
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <div v-if="Object.entries(this.data).length <= 1" class="vx-row w-full">
          <div class="vx-col w-full" style="font-size: 90%">
            Product Category
            <v-select
              autocomplete
              :options="data_options_product_category"
              @input="
                getProductList();
                SetProductName();
              "
              v-model="dataProductCategoryId"
            />
          </div>
          <div class="vx-col w-full" style="font-size: 90%">
            <br />Product
            <v-select
              autocomplete
              :options="data_options_product"
              @input="
                getProductData();
                SetProductName();
              "
              v-model="dataProductId"
            />
            <!-- <vs-button
              v-if="displayExport != false"
              class="vx-col w-full mt-4"
              @click="(activePrompt = true), openPrompt()"
              color="primary"
              type="border"
              >Product not in the list?</vs-button
            > -->
          </div>
        </div>

        <br v-if="Object.entries(this.data).length <= 1" />
        <hr v-if="Object.entries(this.data).length <= 1" class="mt-5 w-full" />
        <div class="vx-row w-full" v-if="dataUom">
          <div class="vx-col w-full">
            <vs-input
              label="Product"
              v-model="dataName"
              class="mt-4 w-full"
              name="name"
              disabled
            />
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              :label="'Quantity (' + dataUom + ')'"
              v-model="dataQuantity"
              style="
                background-color: #ffff99;
                border: 1px solid #ffff99;
                border-radius: 5px;
              "
              @input="SetVolumeTotalAndPriceTotalLive"
              class="mt-4 w-full"
              name="quantity"
            />
          </div>
          <div class="vx-col w-1/2" v-if="dataVisibilityM3">
            <vs-input
              :label="'Current Stock (' + dataUom + ')'"
              v-model="currentStock"
              class="mt-4 w-full"
              disabled
            />
          </div>
          <div class="vx-col w-1/2" v-if="dataVisibilityM3">
            <vs-input
              label="Unit Volume (m3)"
              v-model="dataVolume"
              class="mt-4 w-full"
              name="unitvolume"
              disabled
            />
          </div>
          <div class="vx-col w-1/2" v-if="dataVisibilityM3">
            <vs-input
              label="Volume Total (m3)"
              v-model="dataVolumeTotal"
              class="mt-4 w-full"
              name="volume"
              disabled
            />
          </div>
        </div>
        <hr v-if="dataUom" class="mt-5 w-full" />
        <div v-if="dataUom" class="vx-row w-full">
          <div
            id="div-with-loading-eur"
            class="vs-con-loading__container vx-col w-1/2"
          >
            <vs-input
              :label="'Unit Cost (€/' + dataUom + ')'"
              v-model="dataUnitPrice"
              @input="EditCurrency(1)"
              class="mt-4 w-full"
              name="unit price"
            />
          </div>
          <div
            id="div-with-loading-ron"
            class="vs-con-loading__container vx-col w-1/2"
          >
            <vs-input
              :label="'Unit Cost (RON/' + dataUom + ')'"
              v-model="dataUnitPriceRon"
              @input="EditCurrency(2)"
              class="mt-4 w-full"
              name="unit price"
            />
          </div>
          <div
            v-if="dataVisibilityFieldEuroRonPerm3"
            id="div-with-loading-eur"
            class="vs-con-loading__container vx-col w-1/2"
          >
            <vs-input
              :label="'Unit Cost (€/m3)'"
              v-model="dataUnitPricePerM3"
              @input="EditCostPerM3Currency(1)"
              class="mt-4 w-full"
              name="unit price"
            />
          </div>
          <div
            v-if="dataVisibilityFieldEuroRonPerm3"
            id="div-with-loading-ron"
            class="vs-con-loading__container vx-col w-1/2"
          >
            <vs-input
              :label="'Unit Cost (RON/m3)'"
              v-model="dataUnitPriceRonPerM3"
              @input="EditCostPerM3Currency(2)"
              class="mt-4 w-full"
              name="unit price"
            />
          </div>
          <!--<div class="vx-col w-1/2">
            <vs-input
              label="Theoretical Price (EUR)"
              v-model="dataTheoreticalPrice"
              class="mt-4 w-full"
              name="theoretical price"
              disabled
            />
          </div>-->
          <div class="vx-col w-1/2">
            <vs-input
              label="Total Price (€)"
              v-model="dataTotalPrice"
              v-validate="'required'"
              class="mt-4 w-full"
              name="price"
              disabled
            />
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              label="Total Price (RON)"
              v-model="dataTotalPriceRon"
              v-validate="'required'"
              class="mt-4 w-full"
              name="price"
              disabled
            />
          </div>
          <div class="vx-col w-full">
            <vs-textarea
              label="Description"
              v-model="dataDescription"
              class="mt-4 w-full"
              name="description"
            />
          </div>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>

    <vs-prompt
      @cancel="clearValMultiple"
      @accept="acceptAlert"
      @close="closePrompt"
      :is-valid="validName"
      :active.sync="activePrompt"
    >
      <div class="con-exemple-prompt p-2">
        Add New Product .
        <!-- CATEGORY -->
        <vs-select
          v-model="dataCategoryProd"
          @input="changeNameProd"
          label="Category"
          class="mt-5 w-full"
          name="category"
        >
          <vs-select-item
            :key="item.id"
            :value="item.id"
            :text="item.name_en"
            v-for="item in data_options_categories"
          />
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('category')">{{
          errors.first("category")
        }}</span>
        <!-- SHAPE -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input
              label="Shape"
              v-model="dataShapeProd"
              class="mt-5 w-full"
              name="shape"
              disabled
              v-validate="'required'"
            />
            <span class="text-danger text-sm" v-show="errors.has('shape')">{{
              errors.first("shape")
            }}</span>
          </div>
          <!-- UOMS -->
          <div v-if="uomLockedProd" class="vx-col w-1/2">
            <vs-select
              v-model="dataUomProd"
              @change="getOptionsUoms"
              label="Unit of Measure"
              class="mt-5 w-full"
              name="uom"
              disabled
            >
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.name_en"
                v-for="item in data_options_uoms"
              />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('category')">{{
              errors.first("category")
            }}</span>
          </div>
          <div v-else class="vx-col w-1/2">
            <vs-select
              v-model="dataUomProd"
              @change="getOptionsUoms"
              label="Unit of Measure"
              class="mt-5 w-full"
              name="uom"
            >
              <vs-select-item
                :key="item.id"
                :value="item.id"
                :text="item.name_en"
                v-for="item in data_options_uoms"
              />
            </vs-select>
            <span class="text-danger text-sm" v-show="errors.has('category')">{{
              errors.first("category")
            }}</span>
          </div>
        </div>
        <!-- NAME -->
        <vs-input
          v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8"
          label="Name EN"
          v-model="dataNameProdEN"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <vs-input
          v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8"
          label="Name FR"
          v-model="dataNameProdFR"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <vs-input
          v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8"
          label="Name RO"
          v-model="dataNameProdRO"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <vs-input
          v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8"
          label="Name ES"
          v-model="dataNameProdES"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <vs-input
          v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8"
          label="Name DE"
          v-model="dataNameProdDE"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <vs-input
          v-if="dataShapeIdProd === 5 || dataShapeIdProd === 6 || dataShapeIdProd === 8"
          label="Name NL"
          v-model="dataNameProdNL"
          class="mt-5 w-full"
          name="name"
          v-validate="'required'"
        />
        <vs-input
          v-if="dataShapeIdProd !== 8 && dataShapeIdProd !== 5 && dataShapeIdProd !== 6"
          label="Name"
          v-model="dataNameProdEN"
          class="mt-5 w-full"
          name="name_en"
          disabled
        />
        <span class="text-danger text-sm" v-show="errors.has('name_en')">{{
          errors.first("name_en")
        }}</span>
        <!-- ROULEAU -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input
              v-if="dataShapeIdProd === 7"
              label="Roller Length (m)"
              @input="changeNameProd"
              v-model="dataRollerLengthProd"
              class="mt-5 w-full"
              name="rollerlength"
              v-validate="'decimal'"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('rollerlength')"
              >{{ errors.first("rollerlength") }}</span
            >
          </div>
          <div class="vx-col w-1/2">
            <vs-input
              v-if="dataShapeIdProd === 7"
              label="Stakes Height (m)"
              @input="changeNameProd"
              v-model="dataLengthProd"
              class="mt-5 w-full"
              name="length"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('length')">{{
              errors.first("length")
            }}</span>
          </div>
        </div>
        <!-- LENGTH -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input
              v-if="
                dataShapeIdProd === 1 ||
                dataShapeIdProd === 2 ||
                dataShapeIdProd === 3 ||
                dataShapeIdProd === 4
              "
              label="Length (m)"
              @input="changeNameProd"
              v-model="dataLengthProd"
              class="mt-5 w-full"
              name="length"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('length')">{{
              errors.first("length")
            }}</span>
          </div>
          <div class="vx-col w-1/2">
            <!-- DIAMETER -->
            <vs-input
              v-if="dataShapeIdProd === 1"
              label="Diameter (cm)"
              @input="changeNameProd"
              v-model="dataDiameterProd"
              class="mt-5 w-full"
              name="diameter"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('diameter')">{{
              errors.first("diameter")
            }}</span>
          </div>
        </div>
        <!-- SPACING -->
        <div class="vx-row">
          <div class="vx-col w-1/3">
            <vs-input
              v-if="dataShapeIdProd === 7"
              label="Sp. Min. (cm)"
              @input="changeNameProd"
              v-model="dataSpacing_MinProd"
              class="mt-5 w-full"
              name="spacing_min"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{
              errors.first("spacing")
            }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              v-if="dataShapeIdProd === 7"
              label="Sp. Max. (cm)"
              @input="changeNameProd"
              v-model="dataSpacing_MaxProd"
              class="mt-5 w-full"
              name="spacing_max"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{
              errors.first("spacing")
            }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              v-if="dataShapeIdProd === 7"
              label="Sp. Avg. (cm)"
              v-model="dataSpacing_AvgProd"
              class="mt-5 w-full"
              name="spacing_avg"
              v-validate="'decimal'"
              disabled
            />
            <span class="text-danger text-sm" v-show="errors.has('spacing')">{{
              errors.first("spacing")
            }}</span>
          </div>
        </div>
        <!-- PERIMETER -->
        <div class="vx-row">
          <div class="vx-col w-1/3">
            <vs-input
              v-if="
                dataShapeIdProd === 2 ||
                dataShapeIdProd === 3 ||
                dataShapeIdProd === 7
              "
              label="P. Min. (cm)"
              @input="changeNameProd"
              v-model="dataPerimeter_MinProd"
              class="mt-5 w-full"
              name="perimeter_min"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('radius')">{{
              errors.first("radius")
            }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              v-if="
                dataShapeIdProd === 2 ||
                dataShapeIdProd === 3 ||
                dataShapeIdProd === 7
              "
              label="P. Max. (cm)"
              @input="changeNameProd"
              v-model="dataPerimeter_MaxProd"
              class="mt-5 w-full"
              name="perimeter_max"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('radius')">{{
              errors.first("radius")
            }}</span>
          </div>
          <div class="vx-col w-1/3">
            <vs-input
              v-if="
                dataShapeIdProd === 2 ||
                dataShapeIdProd === 3 ||
                dataShapeIdProd === 7
              "
              label="P. Avg. (cm)"
              v-model="dataPerimeter_AvgProd"
              class="mt-5 w-full"
              name="perimeter_avg"
              v-validate="'decimal'"
              disabled
            />
            <span class="text-danger text-sm" v-show="errors.has('radius')">{{
              errors.first("radius")
            }}</span>
          </div>
        </div>
        <!-- Height -->
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input
              v-if="dataShapeIdProd === 4"
              label="Height (cm)"
              @input="changeNameProd"
              v-model="dataHeightProd"
              class="mt-5 w-full"
              name="height"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('height')">{{
              errors.first("height")
            }}</span>
          </div>
          <!-- Width -->
          <div class="vx-col w-1/2">
            <vs-input
              v-if="dataShapeIdProd === 4"
              label="Width (cm)"
              @input="changeNameProd"
              v-model="dataWidthProd"
              class="mt-5 w-full"
              name="width"
              v-validate="'decimal'"
            />
            <span class="text-danger text-sm" v-show="errors.has('width')">{{
              errors.first("width")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-1/2">
            <vs-input
              v-if="dataShapeIdProd === 7"
              label="Radius 1 Stake (cm)"
              v-model="dataRadiusProd"
              class="mt-5 w-full"
              name="radius"
              disabled
            />
            <span class="text-danger text-sm" v-show="errors.has('volume')">{{
              errors.first("volume")
            }}</span>
          </div>

          <div class="vx-col w-1/2">
            <vs-input
              v-if="dataShapeIdProd === 7"
              label="N. Stakes per Roller"
              @input="changeNameProd(true)"
              v-model="dataNbStakesProd"
              class="mt-5 w-full"
              name="nbstake"
            />
            <span class="text-danger text-sm" v-show="errors.has('nbstake')">{{
              errors.first("nbstake")
            }}</span>
          </div>
        </div>
        <!-- Volume -->
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input
              v-if="dataShapeIdProd === 8"
              label="Volume (m3)"
              v-model="dataVolumeProd"
              class="mt-5 w-full"
              name="vol"
              v-validate="'decimal'"
            />
            <span
              v-if="dataShapeIdProd === 8"
              class="text-danger text-sm"
              v-show="errors.has('vol')"
              >{{ errors.first("vol") }}</span
            >
            <vs-input
              v-if="
                dataShapeIdProd === 1 ||
                dataShapeIdProd === 2 ||
                dataShapeIdProd === 3 ||
                dataShapeIdProd === 4 ||
                dataShapeIdProd === 7
              "
              label="Volume (m3)"
              v-model="dataVolumeProd"
              class="mt-5 w-full"
              name="volume"
              disabled
            />
            <span
              v-if="
                dataShapeIdProd === 1 ||
                dataShapeIdProd === 2 ||
                dataShapeIdProd === 3 ||
                dataShapeIdProd === 4 ||
                dataShapeIdProd === 7
              "
              class="text-danger text-sm"
              v-show="errors.has('volume')"
              >{{ errors.first("volume") }}</span
            >
          </div>
        </div>
      </div>
    </vs-prompt>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import axios from "@/axios.js";
import moduleOperationList from "@/store/operation/moduleOperationList.js";
import moduleDataListProduct from "@/store/products/product/moduleDataList.js";
import vSelect from "vue-select";
import eurRonRate from "@/mixins/eurRonRate";

export default {
  mixins: [eurRonRate],
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
  data() {
    return {
      displayExport: false,
      dataId: null,
      data_options_product_category: [],
      dataProductCategoryId: "",
      data_options_product: [],
      dataProductId: "",
      dataVolume: "",
      dataQuantity: "",
      dataVolumeTotal: "",
      currentStock: null,
      dataTotalPrice: "",
      dataTotalPriceRon: "",
      dataUom: "",
      dataUnitPrice: "",
      dataUnitPricePerM3: "",
      dataUnitPriceRon: "",
      dataUnitPriceRonPerM3: "",
      dataName: "",
      dataDescription: "",
      dataTheoreticalPrice: "",
      dataVisibilityFieldEuroRonPerm3: false,
      dataVisibilityM3: true,
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },

      activePrompt: false,
      backgroundLoading: "primary",
      colorLoading: "#fff",
      dataNameProdEN: "",
      dataNameProdFR: "",
      dataNameProdRO: "",
      dataNameProdES: "",
      dataNameProdNL: "",
      dataNameProdDE: "",
      dataLengthProd: "",
      dataRadiusProd: "",
      dataShapeProd: "",
      dataShapeIdProd: "",
      dataDiameterProd: "",
      dataHeightProd: "",
      dataWidthProd: "",
      dataNbStakesProd: "",
      dataPerimeter_MinProd: "",
      dataPerimeter_MaxProd: "",
      dataPerimeter_AvgProd: "",
      dataCategoryProd: null,
      dataUomProd: null,
      dataVolumeProd: "",
      dataSpacing_MaxProd: "",
      dataRollerLengthProd: "",
      uomLockedProd: "",
      data_options_uoms: [],
      data_options_categories: [],
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 1) {
        this.initValues();
        this.$validator.reset();
        this.dataIdOperation = this.data.idoperation;
      } else {
        this.getStockToday(this.data.operations_products.idproduct);
        // Réinitialiser dataProductId pour éviter les confusions
        this.dataProductId = "";
        this.dataIdOperation = this.data.operations_products.idoperation;
        this.dataDescription = this.data.operations_products.description;
        this.dataName =
          this.data.productcategory.name_en + " " + this.data.name_en;
        this.dataQuantity = this.data.operations_products.quantity;
        this.dataVolume = this.data.volume;
        this.dataVolumeTotal = this.data.volume * this.dataQuantity;
        this.dataUom = this.data.uomsreference.name_en;
        this.dataTheoreticalPrice = this.data.productcategory.price;
        if (this.data.operations_products.unit_price) {
          this.dataUnitPrice = Math.abs(
            this.data.operations_products.unit_price
          );
          this.dataTotalPrice = Math.abs(
            this.data.operations_products.unit_price * this.dataQuantity
          );
          this.dataUnitPricePerM3 = (
            this.dataTotalPrice / this.dataVolumeTotal
          ).toFixed(2);
        }
        if (this.data.operations_products.unit_price_ron) {
          this.dataUnitPriceRon = Math.abs(
            this.data.operations_products.unit_price_ron
          );
          this.dataTotalPriceRon = Math.abs(
            this.data.operations_products.unit_price_ron * this.dataQuantity
          );

          this.dataUnitPriceRonPerM3 = (
            this.dataTotalPriceRon / this.dataVolumeTotal
          ).toFixed(2);

          this.dataVisibilityFieldEuroRonPerm3 = false;
          this.dataVisibilityM3 = true;
        }

        if (
          this.data.productcategory.idproductcategoryshape === 1 ||
          this.data.productcategory.idproductcategoryshape === 2 ||
          this.data.productcategory.idproductcategoryshape === 3 ||
          this.data.productcategory.idproductcategoryshape === 4
        ) {
          this.dataVisibilityFieldEuroRonPerm3 = true;
          this.dataVisibilityM3 = true;
        } else if (this.data.productcategory.idproductcategoryshape === 6) {
          this.dataVisibilityM3 = false;
          this.dataVisibilityFieldEuroRonPerm3 = false;
        }

        this.initValues();
      }
    },
  },
  computed: {
    validName() {
      return this.dataNameProd;
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        (!this.errors.any() && this.dataProductId.value && this.dataQuantity) ||
        (this.data.id && this.dataQuantity)
      );
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    submitDataProd() {
      this.$validator.validateAll().then((result) => {
        //alert(result);
        /*if (result)*/ {
          var longueur = null;
          if (this.dataLengthProd > 0) {
            longueur = this.dataLengthProd * 100;
          } else {
            longueur = null;
          }

          let obj = {};
          if (this.dataShapeId == 5 || this.dataShapeId == 6) {
            obj = {
              id: this.dataIdProd,
              name_en: this.dataNameProdEN,
              name_fr: this.dataNameProdFR,
              name_ro: this.dataNameProdRO,
              name_de: this.dataNameProdDE,
              name_es: this.dataNameProdES,
              name_nl: this.dataNameProdNL,
              height: this.dataHeightProd,
              width: this.dataWidthProd,
              radius: this.dataRadiusProd,
              diameter: this.dataDiameterProd,
              length: longueur,
              isactive: "true",
              volume: this.dataVolumeProd,
              perimeter_min: this.dataPerimeter_MinProd,
              perimeter_max: this.dataPerimeter_MaxProd,
              perimeter_avg: this.dataPerimeter_AvgProd,
              idproductcategory: this.dataCategoryProd,
              iduomsreference: this.dataUomProd,
            };
          } else {
            obj = {
              id: this.dataIdProd,
              name_en: this.dataNameProdEN,
              name_fr: this.dataNameProdEN,
              name_ro: this.dataNameProdEN,
              name_de: this.dataNameProdEN,
              name_es: this.dataNameProdEN,
              name_nl: this.dataNameProdEN,
              height: this.dataHeightProd,
              width: this.dataWidthProd,
              radius: this.dataRadiusProd,
              diameter: this.dataDiameterProd,
              length: longueur,
              isactive: "true",
              volume: this.dataVolumeProd,
              perimeter_min: this.dataPerimeter_MinProd,
              perimeter_max: this.dataPerimeter_MaxProd,
              perimeter_avg: this.dataPerimeter_AvgProd,
              idproductcategory: this.dataCategoryProd,
              iduomsreference: this.dataUomProd,
            };
          }
          delete obj.id;

          this.$store
            .dispatch("dataListProduct/createItem", obj)
            .catch((err) => {
              console.error(err);
            });
          this.$vs.notify({
            color: "success",
            title: "Product Created!",
            text: "The Product was successfully added",
          });
          this.clearValMultiple();
          this.$parent.$parent.toggleDataSidebar(true);
          this.dataProductCategoryId=null;
        }
      });
    },
    changeNameProd(isEditingTheNbOfStake = false) {
      //this.dataName = ''
      const indexCtg = this.data_options_categories.findIndex(
        (p) => p.id === this.dataCategoryProd
      );
      this.dataShapeProd =
        this.data_options_categories[indexCtg].productcategoryshape.name_en;
      this.dataShapeIdProd =
        this.data_options_categories[indexCtg].productcategoryshape.id;


        this.dataNameProdEN = null;
        this.dataNameProdFR = null;
        this.dataNameProdES = null;
        this.dataNameProdDE = null;
        this.dataNameProdNL = null;
        this.dataNameProd = null;
        this.dataNameProdRO = null;
        this.dataVolumeProd = null;
        this.uomLockedProd = true;


      // CYLINDRE
      /*
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
      */
      if (this.dataShapeIdProd === 1) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        //this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 2) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        //this.dataPerimeter_MinProd = null;
        //this.dataPerimeter_MaxProd = null;
        //this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 3) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        //this.dataPerimeter_MinProd = null;
        //this.dataPerimeter_MaxProd = null;
        //this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 4) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        //this.dataHeightProd = null;
        //this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 5) {
        this.dataUomProd = this.data_options_uoms[1].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = 1;
        this.dataNbStakesProd = null;
        this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 6) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 7) {
        this.dataUomProd = this.data_options_uoms[0].id;
        //this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        //this.dataPerimeter_MinProd = null;
        //this.dataPerimeter_MaxProd = null;
        //this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        //this.dataNbStakesProd = null;
        //this.dataLengthProd = null;
        //this.dataSpacing_MinProd = null;
        //this.dataSpacing_AvgProd = null;
        //this.dataSpacing_MaxProd = null;
        //this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }
      if (this.dataShapeIdProd === 8) {
        this.dataUomProd = this.data_options_uoms[0].id;
        this.dataRadiusProd = null;
        this.dataHeightProd = null;
        this.dataWidthProd = null;
        this.dataDiameterProd = null;
        this.dataPerimeter_MinProd = null;
        this.dataPerimeter_MaxProd = null;
        this.dataPerimeter_AvgProd = null;
        this.dataVolumeProd = null;
        this.dataNbStakesProd = null;
        this.dataLengthProd = null;
        this.dataSpacing_MinProd = null;
        this.dataSpacing_AvgProd = null;
        this.dataSpacing_MaxProd = null;
        this.dataRollerLengthProd = null;
        this.uomLockedProd = true;
      }

      if (
        this.dataShapeIdProd === 1 &&
        this.dataLengthProd &&
        this.dataDiameterProd
      ) {
        var diameterplusun = parseFloat(this.dataDiameterProd) + 1;
        var diametermoinsun = this.dataDiameterProd - 1;
        var rangediameter = diametermoinsun + "-" + diameterplusun;
        this.dataNameProdEN =
          /*this.data_options_categories[indexCtg].name_en+*/ "L" +
          this.dataLengthProd +
          "m * d[" +
          rangediameter +
          "]cm";
        axios
          .get(
            "/getvolume/" +
              this.dataShapeIdProd +
              "/" +
              this.dataDiameterProd / 2 +
              "/" +
              this.dataLengthProd * 100
          )
          .then((response) => {
            this.dataVolumeProd = response.data;
          });
      } else if (
        this.dataShapeIdProd === 2 &&
        this.dataLengthProd &&
        this.dataPerimeter_MaxProd &&
        this.dataPerimeter_MinProd
      ) {
        this.dataPerimeter_AvgProd =
          (parseFloat(this.dataPerimeter_MaxProd) +
            parseFloat(this.dataPerimeter_MinProd)) /
          2;
        var rangeP =
          this.dataPerimeter_MinProd + "-" + this.dataPerimeter_MaxProd;
        this.dataNameProdEN =
          /*this.data_options_categories[indexCtg].name_en+*/ "L" +
          this.dataLengthProd +
          "m * P[" +
          rangeP +
          "]cm";

        axios
          .get(
            "/getvolume/" +
              this.dataShapeIdProd +
              "/" +
              this.dataPerimeter_AvgProd +
              "/" +
              this.dataLengthProd * 100
          )
          .then((response) => {
            this.dataVolumeProd = response.data;
          });
      } else if (
        this.dataShapeIdProd === 3 &&
        this.dataLengthProd &&
        this.dataPerimeter_MaxProd &&
        this.dataPerimeter_MinProd
      ) {
        this.dataPerimeter_AvgProd =
          (parseFloat(this.dataPerimeter_MaxProd) +
            parseFloat(this.dataPerimeter_MinProd)) /
          2;
        var rangeP =
          this.dataPerimeter_MinProd + "-" + this.dataPerimeter_MaxProd;
        this.dataNameProdEN =
          /*this.data_options_categories[indexCtg].name_en+*/ "L" +
          this.dataLengthProd +
          "m * P[" +
          rangeP +
          "]cm";

        axios
          .get(
            "/getvolume/" +
              this.dataShapeIdProd +
              "/" +
              this.dataPerimeter_AvgProd +
              "/" +
              this.dataLengthProd * 100
          )
          .then((response) => {
            this.dataVolumeProd = response.data;
          });
      } else if (
        this.dataShapeIdProd === 4 &&
        this.dataLengthProd &&
        this.dataWidthProd &&
        this.dataHeightProd
      ) {
        this.dataNameProdEN =
          /*this.data_options_categories[indexCtg].name_en+*/ "L" +
          this.dataLengthProd +
          "m * W" +
          this.dataWidthProd +
          "cm *  H" +
          this.dataHeightProd +
          "cm";
        axios
          .get(
            "/getvolume/" +
              this.dataShapeIdProd +
              "/" +
              this.dataLengthProd * 100 +
              "/" +
              this.dataWidthProd +
              "/" +
              this.dataHeightProd
          )
          .then((response) => {
            this.dataVolumeProd = response.data;
          });
      } else if (
        this.dataShapeIdProd === 7 &&
        this.dataLengthProd &&
        this.dataPerimeter_MaxProd &&
        this.dataPerimeter_MinProd &&
        this.dataSpacing_MinProd &&
        this.dataSpacing_MaxProd &&
        this.dataRollerLengthProd
      ) {
        this.dataPerimeter_AvgProd =
          (parseFloat(this.dataPerimeter_MaxProd) +
            parseFloat(this.dataPerimeter_MinProd)) /
          2;
        this.dataSpacing_AvgProd =
          (parseFloat(this.dataSpacing_MaxProd) +
            parseFloat(this.dataSpacing_MinProd)) /
          2;
        axios
          .get(
            "/getvolume/77/" +
              this.dataPerimeter_AvgProd +
              "/" +
              this.dataLengthProd * 100
          )
          .then((response) => {
            this.dataRadiusProd = response.data;
            if (isEditingTheNbOfStake != true)
              this.dataNbStakesProd =
                (this.dataRollerLengthProd * 100) /
                (this.dataRadiusProd + this.dataSpacing_AvgProd);
          })
          .then((rs) => {
            axios
              .get(
                "/getvolume/3/" +
                  this.dataPerimeter_AvgProd +
                  "/" +
                  this.dataLengthProd * 100
              )
              .then((response) => {
                if (this.dataNbStakesProd != null) {
                  this.dataVolumeProd = response.data * this.dataNbStakesProd;
                  var rangeP =
                    this.dataPerimeter_MinProd +
                    "-" +
                    this.dataPerimeter_MaxProd;
                  this.dataNameProdEN =
                    "L" +
                    this.dataRollerLengthProd +
                    "m * H" +
                    this.dataLengthProd +
                    "m Spacing:" +
                    this.dataSpacing_AvgProd +
                    "cm (" +
                    parseFloat(this.dataNbStakesProd).toFixed(0) +
                    " * P[" +
                    rangeP +
                    "]cm)";
                } else this.dataNameProdEN = null;
              });
          });
      }
    },
    async getOptionsCategories() {
      axios.get("/productcategory/active/data").then((response) => {
        this.data_options_categories = [...response.data];
      });
    },
    async getOptionsUoms() {
      axios.get("/product/uoms/data").then((response) => {
        this.data_options_uoms = [...response.data];
      });
    },
    EditCostPerM3Currency(idcurrency) {
      if (idcurrency === 1) {
        this.dataUnitPrice = (
          (this.dataUnitPricePerM3 * this.dataVolumeTotal) /
          this.dataQuantity
        ).toFixed(4);
        this.EditCurrencyNoReload(1);
      } else if (idcurrency === 2) {
        this.dataUnitPriceRon = (
          (this.dataUnitPriceRonPerM3 * this.dataVolumeTotal) /
          this.dataQuantity
        ).toFixed(4);
        this.EditCurrencyNoReload(2);
      }
    },
    SetVolumeTotalAndPriceTotalLiveFromM3() {
      this.dataVolumeTotal = (this.dataVolume * this.dataQuantity).toFixed(4);
      this.dataTotalPrice = (
        this.dataVolumeTotal * this.dataUnitPricePerM3
      ).toFixed(4);
      this.dataTotalPriceRon = (
        this.dataVolumeTotal * this.dataUnitPriceRonPerM3
      ).toFixed(4);
    },
    EditCurrencyNoReload(idcurrency) {
      if (idcurrency === 1) {
        /*this.$vs.loading({
          container: "#div-with-loading-ron",
          scale: 0.6,
        });*/
      } else {
        /*this.$vs.loading({
          container: "#div-with-loading-eur",
          scale: 0.6,
        });*/
      }
      /*axios
        .get("/currency/")
        .then((response) => {
          var data_currency = response.data.eur_ron;*/
      if (idcurrency === 1) {
        this.dataUnitPriceRonPerM3 = (
          this.dataUnitPricePerM3 * localStorage.getItem("rate_eur_ron")
        ).toFixed(4);
        this.dataUnitPriceRon = (
          (this.dataUnitPriceRonPerM3 * this.dataVolumeTotal) /
          this.dataQuantity
        ).toFixed(4);
        //this.$vs.loading.close("#div-with-loading-ron > .con-vs-loading");
      } else if (idcurrency === 2) {
        this.dataUnitPricePerM3 = (
          this.dataUnitPriceRonPerM3 / localStorage.getItem("rate_eur_ron")
        ).toFixed(4);
        this.dataUnitPrice = (
          (this.dataUnitPricePerM3 * this.dataVolumeTotal) /
          this.dataQuantity
        ).toFixed(4);
        //this.$vs.loading.close("#div-with-loading-eur > .con-vs-loading");
      }
      this.SetVolumeTotalAndPriceTotalLiveFromM3();
      /*})
        .catch((err) => {
          /*if (idcurrency === 1)
            this.dataUnitPriceRon = (this.dataUnitPrice * 4.83).toFixed(4);
          else this.dataUnitPrice = (this.dataUnitPriceRon / 4.83).toFixed(4);
          this.$vs.loading.close("#div-with-loading-eur > .con-vs-loading");
          this.SetVolumeTotalAndPriceTotalLive();*/
      /*});*/
    },

    EditCurrency(idcurrency) {
      if (idcurrency === 1) {
        /*this.$vs.loading({
          container: "#div-with-loading-ron",
          scale: 0.6,
        });*/
      } else {
        /*this.$vs.loading({
          container: "#div-with-loading-eur",
          scale: 0.6,
        });*/
      }
      /*axios
        .get("/currency/")
        .then((response) => {
          var data_currency = response.data.eur_ron;
          /*this.$vs.notify({
            color: "success",
            title: "Exchange Rate",
            text: "The Exchange Rate: " + data_currency
          });*/
      if (idcurrency === 1) {
        this.dataUnitPriceRon = (
          this.dataUnitPrice * localStorage.getItem("rate_eur_ron")
        ).toFixed(4);
        //this.$vs.loading.close("#div-with-loading-ron > .con-vs-loading");
      } else if (idcurrency === 2) {
        this.dataUnitPrice = (
          this.dataUnitPriceRon / localStorage.getItem("rate_eur_ron")
        ).toFixed(4);
        //this.$vs.loading.close("#div-with-loading-eur > .con-vs-loading");
      }
      this.SetVolumeTotalAndPriceTotalLive();
      /*})
        .catch((err) => {
          /*if (idcurrency === 1)
            this.dataUnitPriceRon = (this.dataUnitPrice * 4.83).toFixed(4);
          else this.dataUnitPrice = (this.dataUnitPriceRon / 4.83).toFixed(4);
          this.$vs.loading.close("#div-with-loading-eur > .con-vs-loading");
          this.SetVolumeTotalAndPriceTotalLive();*/
      //});
    },
    acceptAlert() {
      this.submitDataProd();
    },
    openPrompt() {
      try {
        const indexCtg = this.data_options_categories.findIndex(
          (p) => p.id === this.dataProductCategoryId.value
        );
        this.dataCategoryProd = this.data_options_categories[indexCtg].id;
        this.changeNameProd();
      } catch (error) {}
      this.$emit("closeSidebar");
      //this.initValues();
    },
    closePrompt() {
      this.clearValMultiple();
      this.$parent.$parent.toggleDataSidebar(true);
    },
    clearValMultiple() {
      (this.dataNameProd = ""),
        (this.dataRadiusProd = null),
        (this.dataPerimeter_MinProd = null),
        (this.dataPerimeter_MaxProd = null),
        (this.dataPerimeter_AvgProd = null),
        (this.dataDiameterProd = null),
        (this.dataLengthProd = null),
        (this.dataWidthProd = null),
        (this.dataHeightProd = null),
        (this.dataIsActiveProd = true),
        (this.dataVolumeProd = null),
        (this.dataCategoryProd = null),
        (this.dataUomProd = null);
    },
    getStockToday(idprod) {
      this.currentStock = "0.00";
      axios.get("/getstocktoday/" + idprod).then((response) => {
        this.currentStock = response.data;
      });
    },
    getProductCategoryList() {
      axios
        .get("/productcategory/active-combobox-wood/data")
        .then((response) => {
          this.data_options_product_category = [...response.data];
        });
    },
    getProductList() {
      (this.dataProductId = ""),
        (this.dataVolume = ""),
        (this.dataQuantity = ""),
        (this.dataUom = ""),
        (this.dataVolumeTotal = ""),
        (this.dataUnitPrice = ""),
        (this.dataUnitPriceRon = ""),
        (this.dataTheoreticalPrice = ""),
        (this.dataTotalPrice = ""),
        (this.dataTotalPriceRon = ""),
        axios
          .get(
            "/product/active-combobox/data/" +
              this.dataProductCategoryId.value
          )
          .then((response) => {
            this.data_options_product = [...response.data];
          });
    },
    getProductData() {
      axios
        .get("/product/data/" + this.dataProductId.value)
        .then((response) => {
          if (
            response.data.productcategory.idproductcategoryshape === 1 ||
            response.data.productcategory.idproductcategoryshape === 2 ||
            response.data.productcategory.idproductcategoryshape === 3 ||
            response.data.productcategory.idproductcategoryshape === 4
          ) {
            this.dataVisibilityFieldEuroRonPerm3 = true;
            this.dataVisibilityM3 = true;
          } else if (
            response.data.productcategory.idproductcategoryshape === 6
          ) {
            this.dataVisibilityM3 = false;
            this.dataVisibilityFieldEuroRonPerm3 = false;
          }
          this.dataVolume = response.data.volume;
          this.dataUom = response.data.uomsreference.name_en;
          this.dataTheoreticalPrice = response.data.productcategory.price;
          this.getStockToday(this.dataProductId.value);
        });
    },
    SetProductName() {
      this.dataName =
        this.dataProductCategoryId.label + " " + this.dataProductId.label;
      this.dataDescription = this.dataName;
    },
    SetVolumeTotalAndPriceTotalLive() {
      this.dataVolumeTotal = (this.dataVolume * this.dataQuantity).toFixed(4);
      if (this.dataUnitPrice) {
        this.dataTotalPrice = (this.dataQuantity * this.dataUnitPrice).toFixed(
          4
        );
        this.dataTotalPriceRon = (
          this.dataQuantity * this.dataUnitPriceRon
        ).toFixed(4);
        /*this.dataUnitPriceRonPerM3 = (
          this.dataTotalPriceRon / this.dataVolumeTotal
        ).toFixed(2);
        this.dataUnitPricePerM3 = (
          this.dataTotalPrice / this.dataVolumeTotal
        ).toFixed(2);*/
        this.dataUnitPriceRonPerM3 = (
          this.dataUnitPriceRon / this.dataVolume
        ).toFixed(2);
        this.dataUnitPricePerM3 = (
          this.dataUnitPrice / this.dataVolume
        ).toFixed(2);
      }
    },
    initValues() {
      if (this.data.id) return;
      /*(this.dataProductCategoryId = ""),*/
        (this.dataProductId = ""),
        (this.dataVolume = ""),
        (this.dataQuantity = ""),
        (this.dataUom = ""),
        (this.dataUomId = ""),
        (this.dataVolumeTotal = ""),
        (this.dataUnitPrice = ""),
        (this.dataTheoreticalPrice = ""),
        (this.dataTotalPrice = ""),
        (this.dataTotalPriceRon = ""),
        (this.dataName = ""),
        (this.dataDescription = ""),
        (this.dataUnitPricePerM3 = ""),
        (this.dataUnitPriceRonPerM3 = ""),
        (this.dataVisibilityFieldEuroRonPerm3 = false),
        (this.dataVisibilityM3 = true);
    },

    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          var obj = {};
          var idoperation = null;
          if (this.data.idoperation) idoperation = this.data.idoperation;
          else idoperation = this.data.operations_products.idoperation;
          let quantitytmp = null
          let pricetmp = null
          let price_rontmp = null

          // En mode édition, toujours utiliser this.data.id, ignorer dataProductId
          if (this.data.id !== null && this.data.id >= -10) {
            // Mode édition - utiliser l'ID du produit existant
            quantitytmp = Math.abs(this.dataQuantity);

            if (this.data.id <= -1) {
              pricetmp = -Math.abs(this.dataUnitPrice)
              price_rontmp = -Math.abs(this.dataUnitPriceRon)
            } else {
              pricetmp = Math.abs(this.dataUnitPrice)
              price_rontmp = Math.abs(this.dataUnitPriceRon)
            }

            obj = {
              idoperation: idoperation,
              idproduct: this.data.id,
              quantity: quantitytmp,
              price: pricetmp,
              price_ron: price_rontmp,
              description: this.dataDescription,
            };
          } else if (this.dataProductId.value) {
            // Mode création - utiliser dataProductId
            if (this.dataProductId.value <= -1) {
              quantitytmp = Math.abs(this.dataQuantity)
            } else {
              quantitytmp = Math.abs(this.dataQuantity)
            }

            if (this.dataProductId.value <= -1) {
              pricetmp = -Math.abs(this.dataUnitPrice)
              price_rontmp = -Math.abs(this.dataUnitPriceRon)
            } else {
              pricetmp = Math.abs(this.dataUnitPrice)
              price_rontmp = Math.abs(this.dataUnitPriceRon)
            }

            obj = {
              idoperation: idoperation,
              idproduct: this.dataProductId.value,
              quantity: quantitytmp,
              price: pricetmp,
              price_ron: price_rontmp,
              description: this.dataDescription,
            };
          }
          if (this.data.id !== null && this.data.id >= -10) {
            this.$store
              .dispatch("operationList/updateItem", obj)
              .then((res) => {
                this.$store
                  .dispatch("operationList/fetchm3difference", idoperation)
                  .then((res) => {})
                  .catch((err) => {
                    if (err.response.status === 404) {
                      this.user_not_found = true;
                      return;
                    }
                    console.error(err);
                  });
                this.$vs.notify({
                  color: "success",
                  title: "Product Updated!",
                  text: "The product was successfully updated",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "You cannot add 2 times the same product!",
                  text: "The product was NOT updated",
                });
              });
          } else {
            delete obj.id;
            this.$store
              .dispatch("operationList/createItem", obj)
              .then((res) => {
                this.$store
                  .dispatch("operationList/fetchm3difference", idoperation)
                  .then((res) => {})
                  .catch((err) => {
                    if (err.response.status === 404) {
                      this.user_not_found = true;
                      return;
                    }
                    console.error(err);
                  });
                this.$vs.notify({
                  color: "success",
                  title: "Product Created!",
                  text: "The product was successfully added",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "You cannot add 2 times the same product!",
                  text: "The product was NOT added",
                });
              });
          }
        }
      });
    },
    /*
    submitData() {
      this.$validator.validateAll().then((result) => {
        //alert(this.dataDescription)
        if (result) {
          var obj = {};
          var idoperation = null;
          if (this.data.idoperation) idoperation = this.data.idoperation;
          else idoperation = this.data.operations_products.idoperation;

          if (this.dataProductId.value) {
            obj = {
              idoperation: idoperation,
              idproduct: this.dataProductId.value,
              quantity: -Math.abs(this.dataQuantity),
              price: Math.abs(this.dataUnitPrice),
              price_ron: Math.abs(this.dataUnitPriceRon),
              description: this.dataDescription,
            };
          } else {
            obj = {
              idoperation: idoperation,
              idproduct: this.data.id,
              quantity: -Math.abs(this.dataQuantity),
              price: Math.abs(this.dataUnitPrice),
              price_ron: Math.abs(this.dataUnitPriceRon),
              description: this.dataDescription,
            };
          }
          if (this.data.id !== null && this.data.id >= 0) {
            this.$store
              .dispatch("operationList/updateItem", obj)
              .then((res) => {
                this.$store
                  .dispatch("operationList/fetchm3difference", idoperation)
                  .then((res) => {})
                  .catch((err) => {
                    if (err.response.status === 404) {
                      this.user_not_found = true;
                      return;
                    }
                    console.error(err);
                  });
                this.$vs.notify({
                  color: "success",
                  title: "Product Updated!",
                  text: "The product was successfully updated",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Please delete the product first!",
                  text: "The product was NOT updated",
                });
              });
          } else {
            delete obj.id;
            this.$store
              .dispatch("operationList/createItem", obj)
              .then((res) => {
                this.$store
                  .dispatch("operationList/fetchm3difference", idoperation)
                  .then((res) => {})
                  .catch((err) => {
                    if (err.response.status === 404) {
                      this.user_not_found = true;
                      return;
                    }
                    console.error(err);
                  });
                this.$vs.notify({
                  color: "success",
                  title: "Product Created!",
                  text: "The product was successfully added",
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Please delete the product first!",
                  text: "The product was NOT added",
                });
              });
          }
        }
      });
    },*/
  },
  created() {
    this.getProductCategoryList();
    this.getOptionsCategories();
    this.getOptionsUoms();
    if (!moduleDataListProduct.isRegistered) {
      this.$store.registerModule("dataListProduct", moduleDataListProduct);
      moduleDataListProduct.isRegistered = true;
    }
    this.$store.dispatch("dataListProduct/fetchDataListItems");

    if (localStorage.getItem('login-roles').toLowerCase().includes("admin")) {
      this.displayExport = true
    }
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
